import React from 'react';
import { observer } from 'mobx-react-lite';
import { BasicFormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { IMFormStyled, IMInputTextStyled, IMSubmitButtonStyled } from './styles';

interface Props {
  formController: BasicFormController;
  id: string;
  actionBtnText: string;
  actionBtnIcon: JSX.Element;
  className?: string;
}

const EmployerForm: React.FC<Props> = observer(({ formController, id, actionBtnText, actionBtnIcon, className }) => {
  return (
    <IMFormStyled formController={formController} id={id} className={className}>
      <IMInputTextStyled label="Title" name="title" />
      <IMInputTextStyled label="First Name" name="firstName" maxLength={50} />
      <IMInputTextStyled label="Middle Name" name="middleName" maxLength={50} />
      <IMInputTextStyled label="Last Name" name="lastName" maxLength={50} />
      <IMInputTextStyled label="Email" name="email" />
      <IMInputTextStyled label="Phone" name="telephone" />
      <IMSubmitButtonStyled leftIconProp={actionBtnIcon}>{actionBtnText}</IMSubmitButtonStyled>
    </IMFormStyled>
  );
});

export default EmployerForm;
